// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"196":"ad1e7216af4f21f2","681":"448314b8989c62f7","825":"b5d9c0f1e81bb8db"}[chunkId] + ".js";
};